// The deferred half of the analytics bridge (snippets/bakes-analytics.liquid
// holds the inline half that must run before Shopify's pixel manager).
// Plain JS, no build step. docs/INTEGRATIONS.md has the whole picture.
//
// 1. Outbound and streaming clicks, ported from the site's
//    components/AnalyticsEvents. Same events, same parameters: a click on
//    a link that leaves for another site is a GA4 stream_click when it goes
//    to a streaming service (the host table below, or a data-platform
//    attribute on the link, with data-release naming the release) and an
//    outbound_click otherwise. Our own hosts are part of the journey, not
//    an exit. The event goes through window.gtag, which the inline half
//    holds until the Google & YouTube app has configured the tag, and onto
//    Shopify's analytics bus as bakes:<event> like every island event.
//
// 2. The site's "Do not sell or share" switch wrote bakes_optout=1 on
//    bakesmusic.com. Those visitors were promised the ad pixels stop for
//    them, and on Shopify the ad pixels belong to the channel apps, which
//    obey Shopify's own consent record, not our cookie. So the opt-out is
//    copied into that record once, with the call Shopify's own data sharing
//    opt-out page makes (setTrackingConsent with sale_of_data false). Global
//    Privacy Control needs no copy: Shopify honors it by itself in the
//    regions set under Settings > Customer privacy.
//
// 3. The Customer Privacy API, loaded for the ad gate (see below).
(function (w, d) {
  "use strict";
  // Once per page, even if the file is included twice: two listeners would
  // report every click twice.
  if (w.__bakesAnalyticsJs) return;
  w.__bakesAnalyticsJs = true;

  var STREAM_HOSTS = {
    "open.spotify.com": "spotify",
    "music.apple.com": "apple_music",
    "music.youtube.com": "youtube_music",
    "youtube.com": "youtube",
    "www.youtube.com": "youtube",
    "youtu.be": "youtube",
    "tidal.com": "tidal",
    "soundcloud.com": "soundcloud",
  };

  function own(host) {
    // Matched on the dot, so notbakesmusic.com cannot pass itself off as us.
    // The page's own host covers the myshopify.com preview address.
    return host === "bakesmusic.com" || /\.bakesmusic\.com$/.test(host) || host === w.location.hostname;
  }

  d.addEventListener(
    "click",
    function (e) {
      var t = e.target;
      var a = t && t.closest ? t.closest("a[href^='http']") : null;
      if (!a) return;
      var host;
      try {
        host = new URL(a.href).hostname.toLowerCase();
      } catch (x) {
        return;
      }
      if (!host || own(host)) return;
      var service = a.getAttribute("data-platform") || (Object.prototype.hasOwnProperty.call(STREAM_HOSTS, host) ? STREAM_HOSTS[host] : "");
      var release = a.getAttribute("data-release");
      var name = service ? "stream_click" : "outbound_click";
      var p = { link_domain: host, link_url: a.href };
      if (service) p.service = service;
      if (release) p.release_id = release;
      p.page_path = w.location.pathname;
      try {
        if (typeof w.gtag === "function") w.gtag("event", name, p);
      } catch (x) { /* analytics never blocks a click */ }
      try {
        var bus = w.Shopify && w.Shopify.analytics;
        if (bus && typeof bus.publish === "function") bus.publish("bakes:" + name, p);
      } catch (x) { /* same */ }
    },
    { capture: true, passive: true }
  );

  function cookie(name) {
    try {
      var hit = ("; " + (d.cookie || "")).split("; " + name + "=")[1];
      return hit ? hit.split(";")[0] : "";
    } catch (x) {
      return "";
    }
  }

  function copyOptOut() {
    var S = w.Shopify;
    if (!S || typeof S.loadFeatures !== "function") return;
    S.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) {
      var cp = !err && w.Shopify && w.Shopify.customerPrivacy;
      if (!cp || typeof cp.setTrackingConsent !== "function") return;
      try {
        // Once: after the call Shopify reports the opt-out itself.
        if (cp.saleOfDataAllowed()) cp.setTrackingConsent({ sale_of_data: false }, function () {});
      } catch (x) { /* the theme still drops its own ad calls (inline half) */ }
    });
  }

  // 3. The ad gate (layout/theme.liquid, window.__bakesAdsOk) reads
  //    Shopify's Customer Privacy API before any direct ad tag (backlog
  //    L4-14). Where the cookie banner runs, Shopify has loaded it already;
  //    elsewhere it is loaded here, after the page has loaded, so it is in
  //    place before a visitor can sign up or check out. An opted-out
  //    browser also has its opt-out copied into Shopify's record.
  function loadConsentApi() {
    if (cookie("bakes_optout") === "1") return copyOptOut();
    var S = w.Shopify;
    if (!S || typeof S.loadFeatures !== "function" || S.customerPrivacy) return;
    try {
      S.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function () {});
    } catch (x) { /* the gate falls back to the cookie gate */ }
  }

  if (d.readyState === "complete") loadConsentApi();
  else w.addEventListener("load", loadConsentApi, { once: true });

  // Debug only: say so when the Google tag never arrived, which is what it
  // looks like if Shopify ever runs the app's pixel sandboxed again.
  try {
    if (w.localStorage.getItem("bakes_debug") === "1") {
      w.setTimeout(function () {
        var T = w.__bakesTags;
        if (T && T.g < 2) console.warn("[bakes] no Google tag from the Google & YouTube app after 15s; " + T.hg.length + " event(s) held (consent not given, or the app is not running on this page)");
        if (T && T.f < 2 && T.hf.length) console.warn("[bakes] no Meta pixel from the Facebook & Instagram app after 15s; " + T.hf.length + " call(s) held");
      }, 15000);
    }
  } catch (x) { /* storage refused: no debug */ }
})(window, document);
